import { h, Component } from 'preact';

function niceCeil(value) {
    if (!value || value <= 0) return 1;
    const padded = value * 1.1;
    const magnitude = 10 ** Math.floor(Math.log10(padded));
    return Math.ceil(padded / magnitude) * magnitude;
}

class BarChartVertical extends Component {
    render() {
        const {
            data = [],
            height = 220,
            barColor = 'var(--bs-primary)',
            valueFormat = v => v,
            paddingTop = 24,
            paddingBottom = 28,
            paddingLeft = 28,
            paddingRight = 8,
        } = this.props;

        const width = Math.max(120, data.length * 32);
        const innerWidth = width - paddingLeft - paddingRight;
        const innerHeight = height - paddingTop - paddingBottom;

        const max = data.reduce((m, d) => Math.max(m, d.value || 0), 0);
        const yMax = niceCeil(max);
        const barGap = 6;
        const barWidth = data.length > 0
            ? Math.max(8, (innerWidth - barGap * (data.length - 1)) / data.length)
            : 0;

        const gridSteps = 4;
        const gridLines = [];
        for (let i = 0; i <= gridSteps; i += 1) {
            const y = paddingTop + (innerHeight * i) / gridSteps;
            const labelValue = yMax * (1 - i / gridSteps);
            gridLines.push({ y, labelValue });
        }

        return (
            <svg
                viewBox={`0 0 ${width} ${height}`}
                preserveAspectRatio='xMidYMid meet'
                style={`width: 100%; height: ${height}px; max-height: ${height}px;`}
                role='img'
            >
                {gridLines.map((line, i) => (
                    <g key={`grid-${i}`}>
                        <line
                            x1={paddingLeft}
                            x2={width - paddingRight}
                            y1={line.y}
                            y2={line.y}
                            stroke='currentColor'
                            stroke-opacity={i === gridSteps ? '0.4' : '0.1'}
                            stroke-width='1'
                        />
                        <text
                            x={paddingLeft - 4}
                            y={line.y + 3}
                            text-anchor='end'
                            font-size='9'
                            fill='currentColor'
                            opacity='0.6'
                        >
                            {Math.round(line.labelValue)}
                        </text>
                    </g>
                ))}

                {data.map((d, i) => {
                    const value = d.value || 0;
                    const barHeight = yMax > 0 ? (value / yMax) * innerHeight : 0;
                    const x = paddingLeft + i * (barWidth + barGap);
                    const y = paddingTop + innerHeight - barHeight;
                    // Optional stacked segments [{ label, value, color }] drawn bottom-up
                    // inside the bar; a plain bar is drawn when none are given.
                    const segments = (d.segments || []).filter(seg => (seg.value || 0) > 0);
                    let stackY = paddingTop + innerHeight;
                    return (
                        <g key={`bar-${i}`}>
                            {segments.length === 0 && (
                                <rect
                                    x={x}
                                    y={y}
                                    width={barWidth}
                                    height={barHeight}
                                    fill={d.color || barColor}
                                    rx='2'
                                />
                            )}
                            {segments.map((seg, j) => {
                                const segHeight = yMax > 0 ? (seg.value / yMax) * innerHeight : 0;
                                stackY -= segHeight;
                                return (
                                    <rect
                                        key={`seg-${i}-${j}`}
                                        x={x}
                                        y={stackY}
                                        width={barWidth}
                                        height={segHeight}
                                        fill={seg.color || barColor}
                                    >
                                        <title>{seg.label}: {valueFormat(seg.value)}</title>
                                    </rect>
                                );
                            })}
                            <text
                                x={x + barWidth / 2}
                                y={y - 4}
                                text-anchor='middle'
                                font-size='10'
                                fill='currentColor'
                            >
                                {valueFormat(value)}
                            </text>
                            <text
                                x={x + barWidth / 2}
                                y={height - 8}
                                text-anchor='middle'
                                font-size='10'
                                fill='currentColor'
                                opacity='0.7'
                            >
                                {d.label}
                            </text>
                        </g>
                    );
                })}
            </svg>
        );
    }
}

export default BarChartVertical;
